import React from "react";
import MapView from "./MapView";
import Legend from "./Legend";
import MapFilterLoader from "./MapFilterLoader";

const MapContent = ({ 
  filteredOrgCoords, 
  customLocation, 
  useCustomLocation, 
  isSelectingLocation, 
  proximityRange, 
  handleMapClick, 
  mapRef,
  filtering,
  showCompetitors,
  competitors,
  showPartners,
  partners
}) => {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: "calc(100vh - 130px)" }}>
      <div style={{ flex: 1, width: "100%", position: "relative" }}>
        <MapView 
          filteredOrgCoords={filteredOrgCoords}
          customLocation={customLocation}
          useCustomLocation={useCustomLocation}
          isSelectingLocation={isSelectingLocation}
          proximityRange={proximityRange}
          handleMapClick={handleMapClick}
          mapRef={mapRef}
          showCompetitors={showCompetitors}
          competitors={competitors}
          showPartners={showPartners}
          partners={partners}
        />
        
        {/* Overlay per caricamento durante il filtraggio */}
        {filtering && <MapFilterLoader />}
      </div>
      
      {/* Legenda orizzontale sotto la mappa */}
      <Legend showCompetitors={showCompetitors} showPartners={showPartners} />
    </div>
  );
};

export default MapContent; 